<template>
  <div class="page-maindiv">
    <!-- Main -->
    <div class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t('menu.naviga_spazio').toUpperCase() }}
        </div>
      </div>
      <div class="area-description" v-html="pageDescription"></div>
      <div>
        <div class="w-25"><p class="area-description">Aree di zoom: </p></div>
        <b-button id="button-zoom-lombardia" @click="zoomAtLocation(-1)" variant="info" class="w-100 d-flex justify-content-center align-items-center button-color mx-1">
          {{ "Milano" }}
        </b-button>
        <b-button id="button-zoom-lombardia" @click="zoomAtLocation(-2)" variant="info" class="w-100 d-flex justify-content-center align-items-center button-color mx-1">
          {{ "Lombardia" }}
        </b-button>
        <b-button id="button-zoom-lombardia" @click="zoomAtLocation(-3)" variant="info" class="w-100 d-flex justify-content-center align-items-center button-color mx-1">
          {{ "Italia" }}
        </b-button>
        <b-button id="button-zoom-lombardia" @click="zoomAtLocation(-4)" variant="info" class="w-100 d-flex justify-content-center align-items-center button-color mx-1">
          {{ "Tutto il mondo" }}
        </b-button>
      </div>
      <div id="map-main-div">
        <div id="map-assets" class="border">
          <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                  data-projection="EPSG:4326" ref="map">

            <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

            <vl-layer-tile id="osm">
              <vl-source-osm></vl-source-osm>
            </vl-layer-tile>

            <vl-overlay v-for="place in places" :key="place.id" class="map-overlay" :position="[place.longitudine, place.latitudine]">
              <template>
                <div :class="currentId == place.id ? 'map-circle-on' : 'map-circle-off'" @click="openLocation(place.id)" style="cursor: pointer">
                  {{ place.nAssets }}
                </div>
              </template>
            </vl-overlay>

          </vl-map>
        </div>

        <div id="map-infos-container">
          <div id="map-infos" class="accordion flex-column">
            <b-card no-body class="mb-1" v-for="place in places" :key="place.id">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle="'accordion-' + place.id" :id="'button-accordion-' + place.id" @click="zoomAtLocation(place.id)" variant="info" class="d-flex justify-content-between align-items-center button-color">
                  {{ place.denominazione }}
                  <b-badge variant="primary" pill> {{ place.nAssets }} </b-badge>
                </b-button>
              </b-card-header>
              <b-collapse :id="'accordion-' + place.id" accordion="map-accordion" role="tabpanel" @shown="currentId = place.id" @hide="currentId = -1">
                <b-card-body class="flex-column text-left font-title1">
                  <b-link :to="'/asset/' + asset.id" v-for="asset in assetsByPlace(place.id)" :key="asset.id" class="map-links">
                    <div>{{ $utilities.getTranslation(asset, "nome", $i18n.locale) }}</div>
                    <div class="map-collection-name">{{ getCollectionName(asset.collezione) }}</div>
                  </b-link>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// importing the OpenLayers stylesheet is required for having good looking buttons!
import 'ol/ol.css'

export default {
  data () {
    return {
      pageDescriptionRecord: "",
      zoom: 2,
      center: [0, 0],
      rotation: 0,
      assets: [],
      places: [],
      loading: "(" + this.$t("caricamento") + "...)",
      collections: [],
      structures: [],
      currentId: -1
    }
  },
  computed: {
    pageDescription() {
      let desc = "";
      if (this.pageDescriptionRecord != null)
        for (let trad in this.pageDescriptionRecord["traduzioni"]) {
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith("it"))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
          if (this.pageDescriptionRecord["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale))
            desc = this.pageDescriptionRecord["traduzioni"][trad].contenuto;
        }
      return desc;
    },
  },
  created() {
    this.fetchAssets()
  },
  methods: {
    // Nome della collezione dato l'id
    getCollectionName(idCollection) {
      if (parseInt(idCollection) == 0)
        return "";
      else {
        for (let collection in this.collections)
          if (this.collections[collection].id == idCollection)
            return this.$utilities.getTranslation(this.collections[collection], "nome", this.$i18n.locale);
      }
    },
    async fetchAssets() {
      // Testo pagina
      const pageDescriptionData = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'ricerca_geografica'
          }
        }
      });
      if (pageDescriptionData.data !== null && pageDescriptionData.data.length > 0)
        this.pageDescriptionRecord = pageDescriptionData.data[0];

      // Collezione
      const collectionsData = await this.$client.getItems("collezioni", {fields: ["id", "id_dipartimento", "traduzioni.*"]});
      const collections = collectionsData.data;

      const assetsData = await this.$client.getItems("beni", {
        fields: ["id", "id_collezione", "traduzioni.*"], limit: -1
      });
      this.assets = assetsData.data;

      for (let collection in collections) {
        for (let asset in this.assets) {
          // Valorizza campo che punta alla collezione relativa
          if (this.assets[asset].id_collezione != null && collections[collection].id === this.assets[asset].id_collezione.id) {
            this.assets[asset].collezione = parseInt(collections[collection].id);
          }
        }
      }
      this.collections = collections;

      const places = await this.$client.getItems("luoghi", {
        fields: ["id", "longitudine", "latitudine"], limit: -1
      });
      let placesData = places.data;
      for (let i in placesData) {
        placesData[i].nAssets = 0;
      }

      const assetsPlaces = await this.$client.getItems("beni_luoghi", { fields: ["*"], limit: -1 });
      const assetsPlacesData = assetsPlaces.data;
      for (let i in assetsPlacesData) {
        for (let j in placesData) {
          if (placesData[j].id === assetsPlacesData[i].id_luogo) {
            placesData[j].nAssets++;
          }
        }
        for (let j in this.assets) {
          if (this.assets[j].id === assetsPlacesData[i].id_bene) {
            this.assets[j].place = assetsPlacesData[i].id_luogo;
          }
        }
      }
      this.places = placesData;

      this.loading = "";
    },
    assetsByPlace(placeId) {
      return this.assets.filter(asset => {
        return asset.place == placeId;
      });
    },
    zoomAtLocation(id) {
      if (id < 0) { // Zoom su aree predefinite
        if (id === -1)
          this.$refs.map.$map.getView().fit(this.$refs.map.pointToViewProj([9.1, 45.45]).concat(this.$refs.map.pointToViewProj([9.25, 45.5])))
        else if (id === -2)
          this.$refs.map.$map.getView().fit(this.$refs.map.pointToViewProj([8.8, 45]).concat(this.$refs.map.pointToViewProj([10.85, 46])))
        else if (id === -3)
          this.$refs.map.$map.getView().fit(this.$refs.map.pointToViewProj([7.5, 37.2]).concat(this.$refs.map.pointToViewProj([18.8, 46.6])))
        else if (id === -4)
          this.$refs.map.$map.getView().fit(this.$refs.map.pointToViewProj([-180, -50]).concat(this.$refs.map.pointToViewProj([180, 50])))
      } else { // Zoom su bene selezionato
        // for (let i in this.places) {
          // if (this.places[i].id == id) {
          //   const currentBox = this.$refs.map.$map.getView().calculateExtent();
          //   let box = this.$refs.map.pointToViewProj([this.places[i].longitudine - 1, this.places[i].latitudine - 1])
          //       .concat(this.$refs.map.pointToViewProj([this.places[i].longitudine + 1, this.places[i].latitudine + 1]))
          //   if (currentBox[0] > box[0] && currentBox[2] < box[2] || currentBox[1] > box[1] && currentBox[3] < box[3])
          //     box = currentBox;
          //   this.$refs.map.$map.getView().fit(box)
          // }
        // }

        let VueScrollTo = require('vue-scrollto');
        let options = {
          container: '#map-infos-container',
          easing: 'ease-in',
          lazy: false,
          offset: -60,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        VueScrollTo.scrollTo(document.getElementById("button-accordion-" + id), 100, options);
      }
    },
    openLocation(id) {
      document.getElementById("button-accordion-" + id).click();
    }
  },
}

</script>